import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * 管理画面で入力された HTML を React 要素として描画する。
 *
 * html-react-parser の parse() は XSS-safe ではなく、`<img onerror>` や `<script>` を
 * そのまま React 要素化する。管理画面が侵害された場合の保存型 XSS を防ぐため、
 * 必ず DOMPurify を通してから parse すること。
 *
 * 設定は DOMPurify の既定値のまま（script / イベントハンドラ属性 / javascript: スキームを除去）。
 * 既存の管理画面入力にはテーブルやリンクが含まれるため、allowlist は絞り込んでいない。
 *
 * NOTE: DOMPurifyはwindow/documentが存在しない環境（react_on_railsのmini_racer=SSR実行環境）
 * では`.sanitize`自体が生えない（`require('dompurify').sanitize`が`undefined`になる）ため、
 * SSR時は素通りさせず必ずnullを返す。安全側に倒す（何も描画しない）ことでXSSリスクを増やさず、
 * クラッシュも避ける。中身はCSR後のhydrationで描画される（PR-3では`prerender: true`は未有効化
 * のため実際には発生しないが、有効化する後続PRでは本文がSSR側に出ないぶんの
 * hydrationミスマッチが残る。Rails側で事前サニタイズ済みHTMLをpropsとして渡す等、
 * mini_racerに依存しない解決が必要）
 */
export const parseSanitizedHtml = (html: string | null | undefined) => {
    if (typeof window === 'undefined') {
        return null;
    }
    return parse(DOMPurify.sanitize(html || ''));
};
